export enum CollectionPaymentTypes{
    EXPORT_RECEIVABLES = 'EXPORT RECEIVABLES',
    DUTY_DRAW_BACK= 'DUTY DRAW BACK',
    RODTEP ='RODTEP'
}